import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const formEbook = {
  state: {

  },
  getters: {

  },
  actions: {

    sendFormEbook: ({
      commit
    }, data) => {
      return new Promise((resolve, reject) => {

       // console.log(data);

        axios.post(`/api/leads/register/${data.id}`, data).then(result => {
          if (result.data.status) {
            //DESCARGAS
            resolve(result.data.file)
          }

          if (result.data.error == 0) {
            reject(false)
          }

        }).catch(error => {
          reject(false);
        });
      });
    }
  },
  mutations: {

  }
}

export default formEbook;



// WEBPACK FOOTER //
// ./src/store/formulario-ebook.js